/* Atlas Rug Repair/Restoration — mobile hero-only aspect-ratio correction.
   IMPORTANT: never collapse #root / #canvify-main; this page has content below the hero. */
(() => {
  const MOBILE_MAX = 749;
  const ASPECT = 562.73 / 320.75; // original Restoration desktop/Canva reference ≈ 1.7545
  let applying = false, observer = null, resizeTimer = null;
  const rect = el => el ? el.getBoundingClientRect() : null;

  function largestMedia(hero) {
    return [...hero.querySelectorAll('video,img')]
      .filter(el => { const r = rect(el); return r && r.width > 120 && r.height > 80; })
      .sort((a,b) => { const ar=rect(a), br=rect(b); return br.width*br.height - ar.width*ar.height; })[0] || null;
  }

  function applyFix() {
    if (applying || window.innerWidth > MOBILE_MAX) return;
    const root = document.querySelector('#root');
    const hero = root?.querySelector('section');
    if (!root || !hero) return;
    const media = largestMedia(hero);
    if (!media) return;

    applying = true; if (observer) observer.disconnect();
    try {
      const w = hero.parentElement?.clientWidth || root.clientWidth || document.documentElement.clientWidth;
      const hpx = w / ASPECT;
      const h = `${hpx}px`;

      hero.style.setProperty('height', h, 'important');
      hero.style.setProperty('min-height', h, 'important');
      hero.style.setProperty('max-height', h, 'important');
      hero.style.setProperty('overflow', 'hidden', 'important');

      let el = media.parentElement;
      while (el && el !== hero.parentElement) {
        if (hero.contains(el)) {
          el.style.setProperty('width', '100%', 'important');
          el.style.setProperty('height', h, 'important');
          el.style.setProperty('min-height', h, 'important');
          el.style.setProperty('max-height', h, 'important');
          el.style.setProperty('top', '0', 'important');
          el.style.setProperty('left', '0', 'important');
          el.style.setProperty('transform', 'none', 'important');
          el.style.setProperty('overflow', 'hidden', 'important');
        }
        if (el === hero) break;
        el = el.parentElement;
      }

      media.style.setProperty('width', '100%', 'important');
      media.style.setProperty('height', '100%', 'important');
      media.style.setProperty('position', 'absolute', 'important');
      media.style.setProperty('top', '0', 'important');
      media.style.setProperty('left', '0', 'important');
      media.style.setProperty('transform', 'none', 'important');
      media.style.setProperty('object-fit', 'cover', 'important');
      media.style.setProperty('object-position', 'center center', 'important');
    } finally {
      if (observer) observer.observe(root, {childList:true, subtree:true});
      applying = false;
    }
  }

  function repeat(){ [0,100,250,500,900,1500,2500,4000].forEach(d => setTimeout(() => requestAnimationFrame(applyFix), d)); }
  function init(){ repeat(); const root=document.querySelector('#root'); if(root && !observer){ observer=new MutationObserver(() => { if(!applying) requestAnimationFrame(applyFix); }); observer.observe(root,{childList:true,subtree:true}); } }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
  window.addEventListener('load',repeat,{once:true});
  window.addEventListener('resize',()=>{ clearTimeout(resizeTimer); resizeTimer=setTimeout(repeat,100); });
})();
